import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';

import {ZonaExclusion} from '../../../../../chacra-core';

export {ZonaExclusion} from '../../../../../chacra-core';

export const zonasExclusionAdapter: EntityAdapter<ZonaExclusion> = createEntityAdapter<ZonaExclusion>({
  selectId: model => model.zonaExclusionId,
  sortComparer: (a: ZonaExclusion, b: ZonaExclusion): number =>
    b.zonaExclusionId.toString().localeCompare(a.zonaExclusionId.toString())
});

export interface ZonasExclusionState extends EntityState<ZonaExclusion> {
  isLoading?: boolean;
  error?: string | null;
}

export const initialState: ZonasExclusionState = zonasExclusionAdapter.getInitialState(
  {
    isLoading: false,
    error: null
  }
);
